class SpringContentToggle extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-spring-toggle]');
    this.label = this.querySelector('[data-spring-toggle-label]');
    if (!this.button) return;
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    const expanded = this.classList.toggle('is-expanded');
    this.button.setAttribute('aria-expanded', expanded.toString());
    if (this.label) {
      this.label.textContent = expanded ? this.dataset.labelLess : this.dataset.labelMore;
    }
    if (!expanded) {
      this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }
}

customElements.define('spring-content-toggle', SpringContentToggle);
